// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* swiftref-split-toggle
 * A context-agnostic split-button toggle that displays two options side by side.
 * Left half = off (unchecked / false)
 * Right half = on (checked / true)
 *
 * Labels are configurable via the label-left / label-right attributes.
 * Styling follows the design-system tokens (see src/tokens/index.css).
 */

:host {
    display: inline-block;
    min-width: 180px;
    font-family: var(--font-family), sans-serif;
}

.swiftref-split-toggle {
    display: inline-flex;
    border: 1px solid var(--border-light);
    border-radius: var(--medium-rounding);
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    height: 34px;
    box-sizing: border-box;
    vertical-align: top;
    width: 100%;
}

.swiftref-split-toggle:hover {
    border-color: var(--border-medium, #c8d0d0);
}

.swiftref-split-toggle__half {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--spacing-15);
    font-size: 14px;
    line-height: 1.4;
    background: var(--background-default);
    color: var(--text-default);
    border: none;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
    text-align: center;
    white-space: nowrap;
    height: 100%;
}

.swiftref-split-toggle__half:first-child {
    border-right: 1px solid var(--border-light);
}

.swiftref-split-toggle__half:hover {
    background: var(--background-medium);
}

.swiftref-split-toggle__half--active {
    background: var(--accent-strong-default) !important;
    color: #FFFFFF !important;
}

.swiftref-split-toggle__half--active:hover {
    background: var(--accent-strong-hover) !important;
}

:host([disabled]) .swiftref-split-toggle {
    cursor: not-allowed;
}

:host([disabled]) .swiftref-split-toggle__half {
    background: var(--background-disabled);
    color: var(--text-disabled);
    cursor: not-allowed;
}

:host(:not([message])) swiftref-message {
    margin-top: 0;
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/split_toggle/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,qCAAqC;IACrC,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,OAAO;IACP,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,yDAAyD;IACzD,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB","sourcesContent":["/* swiftref-split-toggle\n * A context-agnostic split-button toggle that displays two options side by side.\n * Left half = off (unchecked / false)\n * Right half = on (checked / true)\n *\n * Labels are configurable via the label-left / label-right attributes.\n * Styling follows the design-system tokens (see src/tokens/index.css).\n */\n\n:host {\n    display: inline-block;\n    min-width: 180px;\n    font-family: var(--font-family), sans-serif;\n}\n\n.swiftref-split-toggle {\n    display: inline-flex;\n    border: 1px solid var(--border-light);\n    border-radius: var(--medium-rounding);\n    overflow: hidden;\n    cursor: pointer;\n    user-select: none;\n    height: 34px;\n    box-sizing: border-box;\n    vertical-align: top;\n    width: 100%;\n}\n\n.swiftref-split-toggle:hover {\n    border-color: var(--border-medium, #c8d0d0);\n}\n\n.swiftref-split-toggle__half {\n    flex: 1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 var(--spacing-15);\n    font-size: 14px;\n    line-height: 1.4;\n    background: var(--background-default);\n    color: var(--text-default);\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n    text-align: center;\n    white-space: nowrap;\n    height: 100%;\n}\n\n.swiftref-split-toggle__half:first-child {\n    border-right: 1px solid var(--border-light);\n}\n\n.swiftref-split-toggle__half:hover {\n    background: var(--background-medium);\n}\n\n.swiftref-split-toggle__half--active {\n    background: var(--accent-strong-default) !important;\n    color: #FFFFFF !important;\n}\n\n.swiftref-split-toggle__half--active:hover {\n    background: var(--accent-strong-hover) !important;\n}\n\n:host([disabled]) .swiftref-split-toggle {\n    cursor: not-allowed;\n}\n\n:host([disabled]) .swiftref-split-toggle__half {\n    background: var(--background-disabled);\n    color: var(--text-disabled);\n    cursor: not-allowed;\n}\n\n:host(:not([message])) swiftref-message {\n    margin-top: 0;\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
